"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
require("./index.scss");
const Pagination_1 = __importDefault(require("@Components/Pagination"));
const contexts_1 = require("@App/contexts");
const PaginationResultsBlock_1 = __importDefault(require("@Components/PaginationResultsBlock"));
const get_num_titles_1 = require("@App/helpers/pagination/get-num-titles");
const CowriterSearchResultRowData_1 = __importDefault(require("@Scenes/SongwriterScene/CowriterSearch/CowriterSearchScene/CowriterSearchResultsTable/CowriterSearchResultRowData"));
const CowriterSearchResults = ({ data, onSelectWriter, onPaginationChange }) => {
    var _a, _b;
    const { cowriterSearchPartyStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const getNumTitlesForSearchResults = () => {
        var _a, _b, _c, _d, _e;
        return (0, get_num_titles_1.getNumTitles)((_b = (_a = cowriterSearchPartyStore.searchResultPartyDetails) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0, (_d = (_c = cowriterSearchPartyStore.publicSearchByPartyCriteriaPaginationInfo) === null || _c === void 0 ? void 0 : _c.currentPage) !== null && _d !== void 0 ? _d : 1, (_e = cowriterSearchPartyStore.currentPartyResultsPerPageLimit) !== null && _e !== void 0 ? _e : 10);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(PaginationResultsBlock_1.default, { workNumTitles: getNumTitlesForSearchResults(), totalResults: (_a = cowriterSearchPartyStore.totalNumberOfResults) !== null && _a !== void 0 ? _a : 0, hideNoResults: true }),
        (data === null || data === void 0 ? void 0 : data.length) > 0 ? (react_1.default.createElement("table", { className: 'cowriter-link-table' },
            react_1.default.createElement("colgroup", null,
                react_1.default.createElement("col", { className: 'cowriter-name-col' }),
                react_1.default.createElement("col", { className: 'cowriter-toggle-col' })),
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("td", null, "Writer Name"),
                    react_1.default.createElement("td", null, "Number of Songs"))),
            react_1.default.createElement("tbody", null,
                react_1.default.createElement(CowriterSearchResultRowData_1.default, { data: data, onSelectWriter: onSelectWriter })))) : (react_1.default.createElement("span", null, " Results Not Found. ")),
        react_1.default.createElement(Pagination_1.default, { limit: (_b = cowriterSearchPartyStore.currentPartyResultsPerPageLimit) !== null && _b !== void 0 ? _b : 10, paginationPages: cowriterSearchPartyStore.publicSearchByPartyCriteriaPaginationInfo, onChange: onPaginationChange })));
};
exports.default = (0, mobx_react_1.observer)(CowriterSearchResults);
